
export class MenuScene extends Phaser.Scene {

    currentScene: number = 0;

    constructor() {
        super({
            key: "MenuScene", active: true //want this scene active first
        });

    }

    preload(): void {

        this.load.image("button1", require("/src/assets/qci/sprites/buttons/square-button-red.png"));
        this.load.image("button2", require("/src/assets/qci/sprites/buttons/square-button-blue.png"));
    }

    create(): void {
        // Get all scenes other than the menu and "scene switcher" scenes
        var scenes = [];
        for (var s of this.scene.manager.scenes.slice(2, this.scene.manager.scenes.length)) {
            scenes.push(s.scene.key);
        }

        // Title
        this.add.text(5, 5, "MENU: CLick through scenes");

        // Menu button
        let menu = this.add.image(700, 100, "button1");
        menu.setInteractive();
        menu.setDisplaySize(100, 100);

        // Menu text
        this.add.text(685, 100, "Menu");

        // Menu onClick
        menu.on('pointerdown', () => {
            this.scene.bringToTop("MenuScene");
        });

        // Next button
        let next = this.add.image(700, 500, "button2");
        next.setInteractive();
        next.setDisplaySize(100, 100);

        // Next text
        this.add.text(685, 500, "Next");

        // Next onClick: go to next scene in the scene list
        next.on('pointerdown', () => {
            // Get next scene from the array and send to the SwitcherScene as the "next" parameter (data.nextScene)
            var nextScene = this.currentScene % (scenes.length);
            // Can pass data to scene using start(<scene>, {<data>})
            this.scene.start("SwitcherScene", { next: scenes[nextScene] });
            this.currentScene++;
        });
    }

    update(): void {

    }

}



// WEBPACK FOOTER //
// ./src/games/demos/phaserMultiSceneDemo/scenes/menuScene.ts